import {seo} from './seo'
import type {FieldsetReturn} from '../types'

export * from './define'
export * from './fieldset'

export const fieldsetDefaults = (): FieldsetReturn[] => [seo()]
export {seo}
